module.exports = __webpack_public_path__ + "img/np.5350291f.svg";